import { useDispatch, useSelector } from 'react-redux'
import { selectTranslations } from '../../services/i18n/i18nSlice'
import { NavLink, useLocation } from 'react-router-dom'
import { useState } from 'react'
import AdminTable from './_components/AdminTable'

import check_img from './images/check.svg'
import waiting_img from './images/clock.svg'
import add_img from '../../assets/images/add.svg'
import user_image from '../../assets/images/user.svg'
import users_image from '../../assets/images/users.svg'
import lock_image from './images/lock.svg'
import settings_img from '../../assets/images/nav_icons/settings.svg'
import AdminPermissionModal from './_components/AdminPermissionModal'

import './UserSettings.css'
import { fetchAddSuperAdmin } from './UsersApi'


export default function UsersAdminsScreen () {

    const t = useSelector(selectTranslations)
    const location = useLocation()
    const [statusFilter, setStatusFilter] = useState("all")
    const [filter, setFilter] = useState({
        deleted: false,
        active: false,
        suspended: false,
        waiting: false,
        is_admin: true,
        skip: 0,
        limit: 20
    })
    const [showNewAdminModal, setShowNewAdminModal] = useState(false)

    const changeStatusFilter = (e) => {
        switch(e.target.value){
            case 'all' : {
                setFilter({
                    ...filter,
                    deleted: false,
                    active: false,
                    suspended: false,
                    waiting: false,
                    is_admin: true,
                })
            } break;
            case 'waiting' : {
                setFilter({
                    ...filter,
                    deleted: false,
                    active: false,
                    suspended: false,
                    waiting: true,
                    is_admin: true,
                })
            } break;
            case 'active' : {
                setFilter({
                    ...filter,
                    deleted: false,
                    active: true,
                    suspended: false,
                    waiting: false,
                    is_admin: true,
                })
            } break;
            default: {
                setFilter({
                    ...filter,
                    deleted: false,
                    active: false,
                    suspended: false,
                    waiting: false,
                    is_admin: true,
                })
            }
        }
        setStatusFilter(e.target.value)
    }

    const addSuperadmin = async () => {
        const response = await fetchAddSuperAdmin('leonardo.curini@thefacultyapp.com')
        if(response.success)
            console.log(response.datails);
            
    }


    return(
        <section id="usersScreen">
            <div className='d-flex align-items-center justify-content-between'>
                <div className='d-flex'>
                    
                    <NavLink to={'/users'}>
                        <div className="page_title not_active">
                            <img src={user_image} />
                            <h1>{t.users.users}</h1>
                        </div>
                    </NavLink>
                    <NavLink to={'/users/groups'}>
                        <div className="page_title not_active ms-4">
                            <img src={users_image} />
                            <h1>{t.users.groups}</h1>
                        </div>
                    </NavLink>
                    <NavLink to={'/users/admins'}>
                        <div className="page_title active ms-4">
                            <img src={lock_image} />
                            <h1>{t.users.admin}</h1>
                        </div>
                    </NavLink>
                </div>
                <div className='d-flex align-items-center'>
                    <button onClick={()=>setShowNewAdminModal(true)}>
                        {t.admins.new_admin}
                        <img src={add_img} />
                    </button>
                    <NavLink to={'/users/settings'} state={{from: location.pathname }}>
                        <div className="page_title not_active ms-4">
                            <img className='ms-2' src={settings_img} />
                        </div>
                    </NavLink>
                </div>
            </div>
            <div className='mt-3'>
                <div className='d-flex mb-3'>
                    <div className='custom-radio'>
                        <input type="radio" id="1" name="statusFilter" value="all" checked={statusFilter === "all"} onChange={changeStatusFilter}/>
                        <label htmlFor="1">
                            {t.users.all}
                        </label>
                    </div>
                    <div className='custom-radio ms-2'>
                        <input type="radio" id="2" name="statusFilter" value="waiting" checked={statusFilter === "waiting"} onChange={changeStatusFilter} />
                        <label htmlFor="2">
                            <img src={waiting_img} className="me-1" />
                            {t.users.waiting}
                        </label>
                    </div>
                    <div className='custom-radio ms-2'>
                        <input type="radio" id="3" name="statusFilter" value="active" checked={statusFilter === "active"} onChange={changeStatusFilter}/>
                        <label htmlFor="3">
                            <img src={check_img} className="me-1" />
                            {t.users.accepted}
                        </label>
                    </div>
                </div>
                <AdminTable defaultFilters={filter}/>
            </div>
            <AdminPermissionModal isNew={showNewAdminModal}  onCloseModal={()=>setShowNewAdminModal(false)} />
        </section>
        
    )
}